import { render } from "./DatabaseInfoScreen.vue?vue&type=template&id=1a13fdc2&scoped=true"
import script from "./DatabaseInfoScreen.vue?vue&type=script&lang=js"
export * from "./DatabaseInfoScreen.vue?vue&type=script&lang=js"

import "./installer-page.scss?vue&type=style&index=0&id=1a13fdc2&lang=scss&scoped=true"
import "./DatabaseInfoScreen.vue?vue&type=style&index=1&id=1a13fdc2&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/installer/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a13fdc2"]])

export default __exports__